import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ListModule } from 'app/shared/components/list/list.module';
import { BasemapGalleryComponent } from './basemap-gallery.component';

@NgModule({
  imports: [CommonModule, ListModule],
  declarations: [BasemapGalleryComponent],
  exports: [BasemapGalleryComponent],
})
export class BasemapGalleryModule {}
